import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getUserDecision } from "../decision";
/**
 * Has the user already consent to the latest requested revision (hash)?
 */

var preDecisionGatewayUserConsent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var decisionCookieName, revisionHash, decision, revision;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            decisionCookieName = _ref.decisionCookieName, revisionHash = _ref.revisionHash;
            decision = getUserDecision(decisionCookieName);

            if (!(decision === false)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            revision = decision.revision;
            return _context.abrupt("return", revisionHash === revision ? "consent" : false);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayUserConsent(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export { preDecisionGatewayUserConsent };